/* eslint-disable import/no-anonymous-default-export */
import Request from './request';
import cookies from 'react-cookies';

const BASE_API_URL = '/';

const fetchTid = async (httpCtx: any) => {
  let tid;
  let pageParams: Record<string, string> = {};
  if (typeof window !== 'undefined') {
    const href = window.location.href;
    if (href.includes('?')) {
      href.split('?')[1].split('&').forEach((i) => {
        pageParams[i.split('=')[0]] = i.split('=')[1];
      })
    }
  }

  const params = {
    channelId: pageParams.utm_source || 100,
    campaignId: pageParams.utm_campaign || 0,
    exposureId: pageParams.utm_medium || 0,
    groupId: pageParams.utm_term || 0,
    salerId: pageParams.utm_content || 0,
  }

  try {
    const res = await httpCtx.get(`/common/proxy/tid`, {params, isCheckTid: false});
    if (res.data && res.data.tid) {
      tid = res.data.tid;
      cookies.save('tid', tid, { path: '/' });
    }
  } catch(e) {
    console.error(e)
  }
  return tid;
}

export default function (config: Record<string, any> = {}) {
  config.baseUrl = config.baseUrl || BASE_API_URL;
  if (config.isCheckTid === undefined) config.isCheckTid = true;
  let tid: any;

  async function send(url: string, options: Record<string, any>) {
    options = options || {};
    config.url = url;
    let { params, query, baseUrl, pathVars, headers, method, responseType, isCheckTid } = { ...options };

    if (isCheckTid === undefined) isCheckTid = config.isCheckTid;

    if (isCheckTid && !tid) {
      tid = await fetchTid(httpCtx);
    }

    const reqArgs: Record<string, any> = {
      url: (baseUrl || config.baseUrl || BASE_API_URL) + url,
      method: method || 'get',
      pathVars,
      params: {},
      headers
    };

    if (responseType) reqArgs.responseType = responseType;

    if (method === 'get') {
      reqArgs.params = params;
    } else {
      if (query) {
        reqArgs.params = query;
      }
      reqArgs.data = params;
    }

    let resp;
    try {
      // console.log('[app]request:', reqArgs);
      resp = await Request(config)(reqArgs);
    } catch (e) {
      resp = e;
    }
    return resp;
  }

  const httpCtx = {
    send,
    get: (url: string, options: Record<string, any>) => {
      options = options || {};
      options.method = 'get';
      return send(url, options);
    },
    post: (url: string, options: Record<string, any>) => {
      options = options || {};
      options.method = 'post';
      return send(url, options);
    },
    put: (url: string, options: Record<string, any>) => {
      options = options || {};
      options.method = 'put';
      return send(url, options);
    },
    delete: (url: string, options: Record<string, any>) => {
      options = options || {};
      options.method = 'delete';
      return send(url, options);
    }
  }

  return httpCtx;
}
